import script from "./CardEvaluacionTutor.vue?vue&type=script&setup=true&lang=js"
export * from "./CardEvaluacionTutor.vue?vue&type=script&setup=true&lang=js"

import "./CardEvaluacionTutor.vue?vue&type=style&index=0&id=7a2ccf14&lang=scss&scoped=true"

import exportComponent from "C:\\development\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a2ccf14"]])

export default __exports__